<template>
  <div>
    <!-- ============================================================== -->
    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <div class="container-fluid">
      <!-- ============================================================== -->
      <!-- Bread crumb and right sidebar toggle -->
      <!-- ============================================================== -->
      <div class="row page-titles">
        <div class="col-md-5 col-8 align-self-center">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/home">Home</router-link>
            </li>
            <li class="breadcrumb-item active">利用者(介護の森)</li>
          </ol>
        </div>
      </div>
      <!-- ============================================================== -->
      <!-- End Bread crumb and right sidebar toggle -->
      <!-- ============================================================== -->
      <div class="row">
        <div class="col-12">
          <!-- Column -->
          <div class="card">
            <div class="card-body">
              <form @submit.prevent="onSubmit">
                <div class="row">
                  <div class="col-4">
                    <div class="form-group" :class="{'has-danger': errors.office_id }">
                      <label class="control-label">事業所</label>
                      <select-office v-model="inputs.office_id" data-vv-as="事業所"/>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-8">
                    <div class="form-group" :class="{'has-danger': errors.file }">
                      <label class="control-label">ファイル</label>
                      <input type="file"
                            class="form-control"
                            accept=".csv"
                            @change="onFileChange" />
                    </div>
                  </div>
                </div>
                <div class="form-actions">
                  <div class="row">
                    <div class="col-md-12 text-center">
                      <button type="submit" class="action-button btn btn-success btn-rounded" :disabled="isProcessing">
                        インポート
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <!-- Column -->
        </div>
      </div>
      <div class="row" v-if="Object.keys(errors).length > 0">
        <div class="col-md-12">
          <div class="alert alert-warning">
            <button type="button" class="close" @click="errorsClear" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <ul>
              <li v-for="(error, index) in errors" :key="index">
                {{ error }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue'
import * as yup from 'yup'
import api from '../../libs/Api'
import SelectOffice from '../../components/SelectOffice'
import { useExecutor } from '@/libs/Executor'
import { useToast } from 'vue-toastification'

const { exec } = useExecutor()
const toast = useToast()

// Reactive data
const inputs = reactive({
  file: null,
  office_id: null
})
const isProcessing = ref(false)
const errors = ref({})

// Schema validation
const schema = yup.object({
  office_id: yup.mixed().required('事業所を入力してください。'),
  file: yup.mixed().required('ファイルを入力してください。')
})

// Methods
const onFileChange = (e) => {
  let files = e.target.files || e.dataTransfer.files
  if (files && files.length > 0) {
    inputs.file = files[0]
  } else {
    inputs.file = null
  }
}

const errorsClear = () => {
  errors.value = {}
}

const validateForm = async () => {
  try {
    await schema.validate(inputs, { abortEarly: false })
    errors.value = {}
    return true
  } catch (validationError) {
    const newErrors = {}
    validationError.inner.forEach(error => {
      newErrors[error.path] = error.message
    })
    errors.value = newErrors
    return false
  }
}

// Form submission
const onSubmit = async () => {
  exec(async () => {
    const isValid = await validateForm()
    if (!isValid) return

    isProcessing.value = true

    const res = await api.importKaigoNoMoriUser(inputs)
    return Promise.resolve(res)
  }).then((res) => {
    if (res) {
      if (res.length > 0) {
        res.forEach((error, index) => {
          errors.value[`line_${index + 1}`] = error
        })
        errors.value.file = '上記の行数が取り込めませんでした。'
      } else {
        toast.success('インポートに成功しました。')
      }
    }
  }).catch((error) => {
    console.error(error)
  }).finally(() => {
    isProcessing.value = false
  })
}
</script>

<style lang="scss" scoped>
.data-actions {
  text-align: right;
}

.table th {
  background-color: #99abb4 !important;
}
</style>
